import { EMPTY_ADDRESS_FORM } from "./components/sede/SedeAziendale";

const KEYS = [
  ["indirizzoVia", "via"],
  ["indirizzoCivico", "civico"],
  ["indirizzoCitta", "citta"],
  ["indirizzoCap", "cap"],
  ["indirizzoProvincia", "provincia"],
  ["indirizzoRegione", "regione"],
  ["indirizzoStato", "stato"],
];

export const PROFILE_ADDRESS_VENDOR_KEYS = KEYS.map(([v]) => v);

export function vendorFormToSedeAddress(vendorFormSlice) {
  const v = vendorFormSlice ?? {};
  const out = { ...EMPTY_ADDRESS_FORM };
  for (const [vk, sk] of KEYS) {
    out[sk] = v[vk] ?? "";
  }
  return out;
}

export function sedeAddressToVendorPatch(sede) {
  const s = sede ?? EMPTY_ADDRESS_FORM;
  const patch = {};
  for (const [vk, sk] of KEYS) {
    patch[vk] = s[sk] ?? "";
  }
  return patch;
}

export function hasAnyAddressValue(vendorFormSlice) {
  return PROFILE_ADDRESS_VENDOR_KEYS.some((k) => String(vendorFormSlice?.[k] ?? "").trim().length > 0);
}

export function pickAddressSnapshot(formLike) {
  const o = {};
  for (const k of PROFILE_ADDRESS_VENDOR_KEYS) {
    o[k] = formLike[k] ?? "";
  }
  return o;
}

export function addressSnapshotsEqual(a, b) {
  const ax = pickAddressSnapshot(a);
  const bx = pickAddressSnapshot(b);
  return PROFILE_ADDRESS_VENDOR_KEYS.every((k) => ax[k] === bx[k]);
}

const SEDE_TO_VENDOR = Object.fromEntries(KEYS.map(([v, sk]) => [sk, v]));

export function sedeFieldKeyToVendorKey(sedeKey) {
  return SEDE_TO_VENDOR[sedeKey] ?? null;
}
